"use client"
import { ConnectKitButton } from "connectkit"
import { useSIWE } from "connectkit"
import { Button } from "@/components/ui/button"

export default function ConnectWalletButton(props: {
  className?: string
  variant?: "default" | "outline" | "secondary" | "ghost" | "link"
}) {
  const { isSignedIn } = useSIWE()

  return (
    <ConnectKitButton.Custom>
      {({ isConnected, isConnecting, show, hide, address, ensName, chain }) => {
        // Determine button text based on connection and verification status
        let buttonText = "Connect wallet"
        if (isConnected) {
          if (isSignedIn) {
            buttonText = address || "Connected"
          } else {
            buttonText = "Verify wallet"
          }
        }

        return (
          <Button
            type="button"
            onClick={(ev) => {
              ev.preventDefault()
              show?.()
            }}
            className={props.className}
            variant={props.variant}
          >
            {buttonText}
          </Button>
        )
      }}
    </ConnectKitButton.Custom>
  )
}
